import { SidebarWrapper } from '../SidebarWrapper'

export const SidebarStepViewThird = () => {
  return <SidebarWrapper title={'Step 3'}>hola</SidebarWrapper>
}
